import { useGetOwners, useGetTradingAccount } from "~/v2/api/hooks";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import {
  type IRAEligibilityResult,
  isEligibleForIRAOnboarding,
} from "./eligibility";

export { isEligibleForIRAOnboarding } from "./eligibility";

/**
 * Hook to determine if a user is eligible for IRA onboarding.
 */
export const useIsEligibleForIRAOnboarding = (): IRAEligibilityResult => {
  const { liveAccounts } = useAccountContext();
  const { account: tradeAccount } = useGetTradingAccount();
  const { owners, isLoading: isOwnersLoading } = useGetOwners({
    accountId: tradeAccount?.id ?? "",
    options: { enabled: !!tradeAccount?.id },
  });

  const primaryOwner = owners?.find((owner) => owner.primary === true);

  return isEligibleForIRAOnboarding({
    accounts: liveAccounts,
    tradeAccount,
    tradeAccountDetails: primaryOwner,
    isLegalEntity: primaryOwner?.is_legal_entity,
    isLoading: !liveAccounts || isOwnersLoading,
  });
};
